import Maybe from 'folktale/maybe'
import { any } from '@wix/wix-data-client-common/dist/esm/infra/unionType'
import { isFieldSortable } from '@wix/wix-data-client-common'
import isFieldFilterable from '@wix/wix-data-client-common/dist/esm/business-logic/fields/isFieldFilterable'

const maybeControllerChanged = (fromPanelState, toPanelState) => {
  const maybeControllers = fromPanelState.matchWith({
    Ready: ({ controller: fromController }) =>
      toPanelState.matchWith({
        Ready: ({ controller: toController }) =>
          Maybe.Just({ fromController, toController }),
        WaitingForExternalPanel: ({ controller: toController }) =>
          Maybe.Just({ fromController, toController }),
        [any]: () => Maybe.Nothing(),
      }),
    WaitingForExternalPanel: ({ controller: fromController }) =>
      toPanelState.matchWith({
        Ready: ({ controller: toController }) =>
          Maybe.Just({ fromController, toController }),
        [any]: () => Maybe.Nothing(),
      }),
    [any]: () => Maybe.Nothing(),
  })
  return maybeControllers.chain(({ fromController, toController }) =>
    fromController.equals(toController)
      ? Maybe.Nothing()
      : Maybe.Just({ fromController, toController }),
  )
}

const getUnusedSortableFields = (collectionFields, sorts) => {
  const usedFieldNames = sorts.map(sortExpression => sortExpression.field)
  return collectionFields.filter(
    field => isFieldSortable(field) && !usedFieldNames.includes(field.name),
  )
}

const getAllowedFilterFields = (fields, controller) =>
  fields.filter(field => isFieldFilterable(controller.controllerType, field))

const getCollection = (panelState, collectionId) =>
  panelState.matchWith({
    Ready: ({ collections }) =>
      collections.find(({ id }) => id === collectionId),
    WaitingForExternalPanel: ({ collections }) =>
      collections.find(({ id }) => id === collectionId),
  })

export {
  maybeControllerChanged,
  getUnusedSortableFields,
  getAllowedFilterFields,
  getCollection,
}
